<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'right',
          labels: {
            boxWidth: 12,
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const dataset = data.datasets[tooltipItem.datasetIndex]
              const value = dataset.data[tooltipItem.index]
              const label = data.labels[tooltipItem.index]
              return `${label}: ${Number(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`
            }
          }
        }
      })
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      handler () {
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/producao/producao-formula-rastreabilidade/GraficoCustosRastreabilidade.vue